import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getDomain = () => {
  const url = window.location.hostname;
  const urlItems = url.split('.');
  if (urlItems.length === 1) return url;
  urlItems.shift();
  const domain = urlItems.join('.');
  return `.${domain}`;
};

export const setFeatureFlag = (key, enabled) => {
  cookies.set(key, enabled, { path: '/', domain: getDomain() });
};

export const getFeatureFlag = (key) => {
  return cookies.get(key) == 'true';
};
